export const PAGE_LIMIT = 50; // Represents the default number of results per requested table page
